import React, { useState, useEffect } from "react";
import { FaTimes, FaChartLine, FaCheckCircle, FaLayerGroup, FaChevronRight, FaChevronLeft, FaClock, FaPlayCircle } from "react-icons/fa";
import CONFIG from "../config"; // Assuming config is in src/config, adjust path if logic is in subfolder
import "../Foydalanuvchi/StatisticsModal.css"; // Reuse existing styles
import LogicCharts from "./LogicCharts";
import StatisticsInfoModal from "./StatisticsInfoModal";
import { FaInfoCircle } from "react-icons/fa";

const formatTime = (seconds) => {
    if (!seconds) return "00:00";
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
};

const LogicStatisticsModal = ({ isOpen, onClose, userData }) => {
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedSection, setSelectedSection] = useState(null);
    const [showCharts, setShowCharts] = useState(false);
    const [showInfo, setShowInfo] = useState(false);

    useEffect(() => {
        if (isOpen) {
            fetchStats();
        } else {
            setSelectedSection(null);
            setShowCharts(false);
        }
    }, [isOpen]);

    const fetchStats = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("loyiha_token");
            // Assuming CONFIG is accessible. 
            // If Taxrirlovchi is in src/Taxrirlovchi, config is ../config.js which is correct.
            const res = await fetch(`${CONFIG.API_BASE_URL}/get_logic_statistics.php`, {
                headers: { 'Authorization': `Bearer ${token}` }
            }).then(r => r.json());

            if (res.status === 'success') {
                setStats(res.data);
            }
        } catch (err) {
            console.error("Stats fetch error:", err);
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    const renderSectionsList = () => (
        <div className="course-stats-grid">
            {stats.filter(s => s.solved_problems > 0).map((sec) => (
                <div key={sec.id} className="course-stat-card" onClick={() => {
                    setSelectedSection(sec);
                    setShowCharts(true); // Auto show charts/details
                }}>
                    <div className="card-top">
                        <div className="course-info">
                            <div className="course-name-row">
                                <div className="course-title-wrapper">
                                    <FaLayerGroup className="course-type-icon" />
                                    <span className="course-name">{sec.nomi}</span>
                                </div>
                                <div className="progress-pill">
                                    <span className="progress-text">{sec.progress}%</span>
                                </div>
                            </div>
                            <div className="progress-bar-wrapper">
                                <div
                                    className="progress-fill"
                                    style={{ width: `${sec.progress}%` }}
                                ></div>
                            </div>
                        </div>
                    </div>

                    <div className="card-metrics">
                        <div className="metric-item">
                            <FaCheckCircle className="metric-icon complete-icon" />
                            <div className="metric-details">
                                <span className="metric-label">Yechilgan</span>
                                <span className="metric-value">{sec.solved_problems}/{sec.total_problems}</span>
                            </div>
                        </div>
                        <div className="metric-item">
                            <FaClock className="metric-icon time-icon" />
                            <div className="metric-details">
                                <span className="metric-label">Jami Vaqt</span>
                                <span className="metric-value">{formatTime(sec.total_time_spent)}</span>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <span>Tahlilni ko'rish</span>
                        <FaChevronRight />
                    </div>
                </div>
            ))}
        </div>
    );

    const renderDetails = () => (
        <div className="topic-details-view">
            <div className="details-header" style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
                <button className="back-btn" onClick={() => setSelectedSection(null)} style={{ margin: 0 }}>
                    <FaChevronLeft /> Ortga
                </button>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <FaInfoCircle
                        className="info-icon-btn"
                        title="Baholash tizimi haqida"
                        onClick={() => setShowInfo(true)}
                        style={{ color: '#999', cursor: 'pointer', fontSize: '1.2rem' }}
                    />
                    <h3 style={{ margin: 0 }}>{selectedSection.nomi}</h3>
                </div>
            </div>

            <LogicCharts section={selectedSection} />

            <div className="topics-list" style={{ marginTop: '30px' }}>
                <h4 style={{ marginBottom: '15px' }}>Masalalar Ro'yxati</h4>
                {selectedSection.problems.map((p, index) => (
                    <div
                        key={p.id}
                        className={`topic-item ${p.is_solved ? 'passed' : ''}`}
                        style={{ '--index': index }}
                    >
                        <div className="topic-info">
                            <span className="topic-index">{index + 1}.</span>
                            <span className="topic-name">{p.nomi}</span>
                        </div>
                        <div className="topic-results">
                            {p.has_video && (
                                <div className="topic-result-badge" title="Video Yordam">
                                    {p.used_video_help ? (
                                        <><FaPlayCircle style={{ color: '#9b59b2' }} /> Oldi</>
                                    ) : (
                                        <><FaPlayCircle style={{ color: '#ccc' }} /> Yo'q</>
                                    )}
                                </div>
                            )}

                            <div className="topic-result-badge" title="Sarflangan vaqt">
                                <FaClock /> {formatTime(p.solve_time)}
                            </div>

                            {p.is_solved ? (
                                <FaCheckCircle className="topic-done-icon" />
                            ) : (
                                <div className="topic-pending-icon"></div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <div className="stats-modal-overlay" onClick={onClose}>
            <div className="stats-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="stats-header">
                    <div className="header-title">
                        <FaChartLine className="header-icon" />
                        <h2>Grafik Tahlil</h2>
                    </div>
                    <button className="close-btn" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="stats-body">
                    {loading ? (
                        <div className="stats-loading">
                            <div className="loader"></div>
                            <p>Ma'lumotlar yuklanmoqda...</p>
                        </div>
                    ) : stats.length > 0 ? (
                        selectedSection ? renderDetails() : renderSectionsList()
                    ) : (
                        <div className="no-stats">
                            <p>Hozircha ma'lumot yo'q.</p>
                        </div>
                    )}
                </div>
            </div>

            <StatisticsInfoModal isOpen={showInfo} onClose={() => setShowInfo(false)} mode="logic" />
        </div >
    );
};

export default LogicStatisticsModal;
